<template>
  <div v-if="isLoading" class="loading-overlay">
    <div class="loading-container">
      <!-- 旋转的圆圈动画 -->
      <div class="spinner">
        <div class="spinner-inner"></div>
      </div>
      
      <!-- 加载文字 -->
      <div class="loading-text">
        <span class="loading-dots">
          <span class="dot">.</span>
          <span class="dot">.</span>
          <span class="dot">.</span>
        </span>
      </div>
      
      <!-- 可选的加载提示文字 -->
      <div v-if="loadingText" class="loading-message">{{ loadingText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 40px 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  min-width: 200px;
  text-align: center;
}

/* 旋转动画 */
.spinner {
  width: 50px;
  height: 50px;
  position: relative;
  margin-bottom: 20px;
}

.spinner-inner {
  width: 100%;
  height: 100%;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 加载文字样式 */
.loading-text {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  margin-bottom: 10px;
}

.loading-dots {
  display: inline-block;
}

.dot {
  animation: dotPulse 1.4s infinite ease-in-out;
  animation-fill-mode: both;
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}

.dot:nth-child(2) {
  animation-delay: -0.16s;
}

.dot:nth-child(3) {
  animation-delay: 0s;
}

@keyframes dotPulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
}

/* 加载提示文字 */
.loading-message {
  font-size: 14px;
  color: #666;
  margin-top: 8px;
  max-width: 200px;
  line-height: 1.4;
}

/* 响应式设计 */
@media (max-width: 767px) {
  .loading-container {
    padding: 30px 20px;
    min-width: 160px;
    margin: 0 20px;
  }
  
  .spinner {
    width: 40px;
    height: 40px;
    margin-bottom: 15px;
  }
  
  .spinner-inner {
    border-width: 3px;
  }
  
  .loading-text {
    font-size: 14px;
  }
  
  .loading-message {
    font-size: 12px;
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .loading-container {
    padding: 35px 25px;
  }
  
  .spinner {
    width: 45px;
    height: 45px;
  }
}

/* 深色主题支持 */
@media (prefers-color-scheme: dark) {
  .loading-container {
    background: rgba(30, 30, 30, 0.95);
    color: #fff;
  }
  
  .loading-text {
    color: #fff;
  }
  
  .loading-message {
    color: #ccc;
  }
  
  .spinner-inner {
    border-color: #444;
    border-top-color: #007bff;
  }
}
</style>
